import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import type { VariableGroup } from '@dealstack/frontend/shared/components/EmailTemplates/utils/variableGroups';

export const useVariableGroupLabel = () => {
	const tMipManage = useTranslationMipManage();

	return (group: VariableGroup): string => {
		switch (group) {
			case 'recipient':
				return tMipManage('email_templates.variables.groups.recipient', {
					defaultValue: 'Recipient',
				});
			case 'deal':
				return tMipManage('email_templates.variables.groups.deal', {
					defaultValue: 'Deal',
				});
			case 'links':
				return tMipManage('email_templates.variables.groups.links', {
					defaultValue: 'Links',
				});
			case 'custom':
				return tMipManage('email_templates.variables.groups.custom', {
					defaultValue: 'Custom',
				});
		}
	};
};
